import { VehicleStatus } from "../../../Enum/vehcile-status.enum"

export class VehicleIdReq{
    vehicleId:number
    status?:VehicleStatus
    hodApprovalDate?:any
    vehicleRequest?:string
    constructor(
        vehicleId:number,
        status?:VehicleStatus,
       hodApprovalDate?:any,
       vehicleRequest?:string
    ){
        this.vehicleId=vehicleId
        this.status=status
        this.hodApprovalDate=hodApprovalDate
        this.vehicleRequest=vehicleRequest
    }
}

export class roleReq{
    role:string
    user?:string
    externalRefNo?:string
    vehicleReqCode?:string
    vehicleRequiredOn?:string
    vehicletype?:string
    plant?:string
    unit?:string
    constructor(role?:string,
    user?:string,
    externalRefNo?:string,
    vehicleReqCode?:string,
    vehicleRequiredOn?:string,
    vehicletype?:string,
    plant?:string,
    unit?:string
    

    ){
        this.role=role
        this.user=user
        this.externalRefNo = externalRefNo
        this.vehicleReqCode=vehicleReqCode
        this.vehicleRequiredOn=vehicleRequiredOn
        this.vehicletype=vehicletype
        this.plant=plant
        this.unit=unit

    }
}

export class AssignVendor{

    vehicleReqIds:number[]
    vehicleType:string
    vendorId:number
    approvalDate:any

    constructor(
        vehicleReqIds:number[],
    vehicleType:string,
    vendorId:number,
    approvalDate:any
    ){
        this.vehicleReqIds = vehicleReqIds
        this.vehicleType = vehicleType
        this.vendorId = vendorId
        this.approvalDate = approvalDate

    }
}

export class DriverUpdateReq{
    role?:string
    driverId?:number
    vehicleReqId?:number
    vendorCode?:string
    employeeContactNumber?:string
    driverContactNumber?:string
    source?:string
    destination?:string
    requiredOn?:string
    employee?:string
    driverName?:string
    pickUpTime?:any

    constructor(
        role?:string,
        driverId?:number,
        vehicleReqId?:number,
        vendorCode?:string,
        employeeContactNumber?:string,
        driverContactNumber?:string,
        source?:string,
        destination?:string,
        requiredOn?:string,
        employee?:string,
        driverName?:string

    ){
        this.role=role
        this.driverId=driverId
        this.vehicleReqId=vehicleReqId
        this.vendorCode=vendorCode
        this.employeeContactNumber=employeeContactNumber
        this.driverContactNumber=driverContactNumber
        this.source=source
        this.destination=destination
        this.requiredOn=requiredOn
        this.employee=employee
        this.driverName=driverName
    }
}